export function calculateHotelPrices(
  price: number | string,
  offerCharge: string | number,
  duration: number,
) {
  const totalPrice = Number(price) || 0;
  const pricePerNight = totalPrice / duration || 0;

  const charge = Math.abs(Number(offerCharge || 0));
  const originalPrice = totalPrice + charge;
  const originalPricePerNight = originalPrice / duration || 0;

  const discountPercent = (charge / originalPrice) * 100;

  return {
    totalPrice,
    pricePerNight,
    originalPrice,
    originalPricePerNight,
    discountPercent,
  };
}
